// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom"; // use Link for SPA navigation
// import "./ProductCard.css";
// import axios from "axios";

// function ProductCard() {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [Product, setProduct] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details"
//       );
//       setProduct(response.data.data);
//     };

//     fetchData();
//   }, []);

//   const openImage = (src) => setSelectedImage(src);
//   const closeImage = () => setSelectedImage(null);

//   return (
//     <section className="product-section bg-white" style={{ backgroundColor:"#f0f0f0", paddingTop:"50px"}}>
//       <div className="container">
//         <div className="row">
//           {Product.map((product, index) => (
//             <div
//               className="col-lg-3 col-md-6 col-sm-6 col-xs-12 article_padding card-sec"
//               key={index}
//             >
//               <div className="offer_boxcontent">
//                 <div className="upper_portion">
//                   <div
//                     className="article_img"
//                     onClick={() =>
//                       openImage(`https://cyberathon.com/NLF/${product.pro_image}`)
//                     }
//                   >
//                     <figure className="mb-0">
//                       <img
//                         src={`https://cyberathon.com/NLF/${product.pro_image}`}
//                         className="clickable-img"
//                         alt={product.prod_heading}
//                       />
//                     </figure>
//                   </div>
//                 </div>
//                 <div className="lower_portion_wrapper">
//                   <div className="lower_portion">
//                     <h4 className="mb-0">{product.prod_heading}</h4>
//                   </div>

//                   {/* Individual link for each product */}
//                   <Link
//                     className="read_more text-white text-decoration-none"
//                     to={`/product/${product.prod_id}`}
//                   >
//                     Read More
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Modal / Lightbox */}
//       {selectedImage && (
//         <div className="image-modal" onClick={closeImage}>
//           <div
//             className="image-modal-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <img src={selectedImage} alt="Expanded" className="expanded-img" />
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// export default ProductCard;

// Before loader on 21march
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";

// function ProductCard() {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [allProducts, setAllProducts] = useState([]);

//   useEffect(() => {
//   const fetchAllData = async () => {
//     try {
//       const [mainRes, productRes] = await Promise.all([
//         axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_main_card"
//         ),
//         axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details"
//         )
//       ]);


//       // 🔹 Normalize Main Cards
//       const mainCards = (mainRes.data.data || []).map(item => ({
//         type: "mainCard",
//         id: item.main_id,
//         heading: item.name,
//         image: item.image,
//         order: Number(item.order), // 🔥 IMPORTANT
//         linkPath: `/subcard/${item.main_id}`
//       }));

//       // 🔹 Normalize Products
//       const products = (productRes.data.data || []).map(item => ({
//         type: "product",
//         id: item.prod_id,
//         heading: item.prod_heading,
//         image: item.pro_image,
//         order: Number(item.order), // 🔥 IMPORTANT
//         linkPath: `/product/${item.prod_id}`
//       }));

//       // 🔹 MERGE + SORT (THIS MAKES ADMIN REFLECTION WORK)
//       const merged = [...products, ...mainCards].sort(
//         (a, b) => a.order - b.order
//       );

//       setAllProducts(merged);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   fetchAllData();
// }, []);


//   const openImage = (src) => setSelectedImage(src);
//   const closeImage = () => setSelectedImage(null);

//   return (
//     <>
//       {/* Combined Products Section */}
//       <section className="product-section bg-white" style={{ backgroundColor: "#f0f0f0", paddingTop: "50px" }}>
//         <div className="container">
//           <div className="row">
//             {allProducts.map((item, index) => (
//               <div
//                 className="col-lg-3 col-md-6 col-sm-6 col-xs-12 article_padding card-sec"
//                 key={`${item.type}-${item.id}`}
//               >
//                 <div className="offer_boxcontent">
//                   <div className="upper_portion">
//                     <div
//                       className="article_img"
//                       onClick={() =>
//                         openImage(`https://cyberathon.com/NLF/${item.image}`)
//                       }
//                     >
//                       {/* <figure className="mb-0"> */}
//                        <figure className="mb-0 image-wrapper1">
//                         <img
//                           src={`https://cyberathon.com/NLF/${item.image}`}
//                           className="clickable-img"
//                           alt={item.heading}
//                         />
//                       </figure>
//                     </div>
//                   </div>
//                   <div className="lower_portion_wrapper">
//                     <div className="lower_portion">
//                       <h4 className="mb-0">{item.heading}</h4>
//                     </div>
//                     <Link
//                       className="read_more text-white text-decoration-none"
//                       to={item.linkPath}
//                     >
//                       Read More
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             ))}

//           </div>
//         </div>
//       </section>

//       {/* Modal / Lightbox */}
//       {selectedImage && (
//         <div className="image-modal" onClick={closeImage}>
//           <div
//             className="image-modal-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <img src={selectedImage} alt="Expanded" className="expanded-img" />
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ProductCard;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import PageLoader from "../PageLoader"; // ← import karo
import "../Contact/Branches.css";

function ProductCard() {
  // ✅ SEO-friendly URLs — ye cards fixed pages pe jayenge
  const seoLinkMap = {
    "Next-Gen Roofing System": "/services/next-gen-roofing",
    "Furniture for Everyone": "/services/furniture-for-everyone",
    "Acoustics for Every Space": "/services/acoustics-for-every-space",
    "Metal Ceiling & Facade": "/facade-solutions-metal-ceiling"
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true); // ← add karo

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true); // ← add
      try {
        const [mainRes, productRes] = await Promise.all([
          axios.get("https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_main_card"),
          axios.get("https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details")
        ]);

        const mainCards = (mainRes.data.data || []).map(item => ({
          type: "mainCard",
          id: item.main_id,
          heading: item.name,
          image: item.image,
          order: Number(item.order),
          linkPath: seoLinkMap[item.name] || `/subcard/${item.main_id}`
        }));

        const products = (productRes.data.data || []).map(item => ({
          type: "product",
          id: item.prod_id,
          heading: item.prod_heading,
          image: item.pro_image,
          order: Number(item.order),
          linkPath: seoLinkMap[item.prod_heading] || `/product/${item.prod_id}`
        }));

        const merged = [...products, ...mainCards].sort((a, b) => a.order - b.order);
        setAllProducts(merged);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // ← finally mein rakho taaki error pe bhi loader band ho
      }
    };

    fetchAllData();
  }, []);

  if (loading) return <PageLoader />; // ← add karo

  const openImage = (src) => setSelectedImage(src);
  const closeImage = () => setSelectedImage(null);

  return (
    <>
      <section className="product-section bg-white" style={{ backgroundColor: "#f0f0f0", paddingTop: "50px" }}>
        <div className="container">
          <div className="row">
            {allProducts.map((item, index) => (
              <div
                className="col-lg-3 col-md-6 col-sm-6 col-xs-12 article_padding card-sec"
                key={`${item.type} - ${item.id}`}
              >
                <div className="offer_boxcontent">
                  <div className="upper_portion">
                    <div
                      className="article_img"
                      onClick={() => openImage(`https://cyberathon.com/NLF/${item.image}`)}
                    >
                      <figure className="mb-0 image-wrapper1">
                        <img
                          src={`https://cyberathon.com/NLF/${item.image}`}
                          className="clickable-img"
                          alt={item.heading}
                        />
                      </figure>
                    </div >
                  </div >
                  <div className="lower_portion_wrapper">
                    <div className="lower_portion">
                      <h4 className="mb-0">{item.heading}</h4>
                    </div>
                    <Link
                      className="read_more text-white text-decoration-none"
                      to={item.linkPath}
                    >
                      Read More
                    </Link>
                  </div>
                </div >
              </div >
            ))
            }
          </div >
        </div >
      </section >

      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Expanded" className="expanded-img" />
          </div>
        </div>
      )}
    </>
  );
}

export default ProductCard;